import React from "react";
import Table from "../list/Table";
import { Link } from "react-router-dom";
import { IoMdPersonAdd, IoMdDocument } from "react-icons/io";
import { useTranslation } from "react-i18next";
import objectPath from "object-path";
import { API_ROOT } from "../defines";
import { classificationType } from "../type/Form";
import moment from "moment";

const List = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col ">
      <div className="flex items-center justify-between w-full h-20 py-3 px-8">
        <div className="text-xl font-semibold leading-5 text-black ">
          Тэмдэг
        </div>
        <Link
          to={`new`}
          className="p-2 border-2 rounded hover:cursor-pointer border-primary"
        >
          <IoMdDocument color="#1A2E55" />
        </Link>
      </div>
      <div className="px-4">
        <Table
          url={`/advice/table`}
          sort={{ _id: -1 }}
          columns={[
            {
              label: t("advice.file"),
              key: `file`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ _id, file }) => {
                const url = API_ROOT + "/" + objectPath.get(file, "0.id");

                return (
                  <img
                    crossOrigin="anonymous"
                    className="h-20 rounded bg-contain self-center"
                    src={url}
                  />
                );
              },
            },
            {
              label: t("advice.title"),
              key: `title`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ _id, title }) => {
                return (
                  <Link to={`view/${_id}`}>
                    <div class="text-primary underline font-semibold">
                      {title}
                    </div>
                  </Link>
                );
              },
            },
            {
              label: t("advice.link"),
              key: `link`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("createdby"),
              key: `createdby.email`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("created"),
              // label: `Бүртгэсэн огноо`,
              key: `created`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ created }) =>
                moment(created).format("YYYY-MM-DD HH:mm:ss"),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default List;
